import React, { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../services/analytics';

// Optional: Context for organization/event data
const AnalyticsContext = React.createContext();

export const AnalyticsProvider = ({ sourceName, children }) => {
  return (
    <AnalyticsContext.Provider value={{ sourceName }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = () => {
  const location = useLocation();
  const context = useContext(AnalyticsContext);

  // Track page views automatically
  useEffect(() => {
    analytics.trackPageView(
      location.pathname + location.search,
      document.referrer,
      context?.sourceName
    );
  }, [location, context?.sourceName]);

  const trackEvent = (
    eventName,
    eventCategory,
    eventData = {},
    organizationId,
    eventInstanceId
  ) => {
    return analytics.track(
      eventName,
      eventCategory,
      eventData,
      organizationId,
      eventInstanceId
    );
  };

  const trackClick = (buttonName) => {
    return analytics.trackButtonClick(buttonName, location.pathname);
  };

  const trackForm = (action, formName, step = null) => {
    return analytics.trackFormInteraction(action, formName, step);
  };

  const trackRegistration = (
    action,
    data = {},
    organizationId,
    eventInstanceId
  ) => {
    return analytics.trackRegistrationFunnel(
      action,
      eventInstanceId,
      organizationId,
      data
    );
  };

  return {
    trackEvent,
    trackClick,
    trackForm,
    trackRegistration,
    sessionId: analytics.sessionId,
    sourceName: context?.sourceName
  };
};
